export function formatStageAge(ms) {
    if (ms == null || !Number.isFinite(ms) || ms < 0)
        return '';
    const days = Math.floor(ms / 86_400_000);
    const hours = Math.floor((ms % 86_400_000) / 3_600_000);
    if (days > 0)
        return `${days} д ${hours} ч`;
    if (hours > 0)
        return `${hours} ч`;
    const minutes = Math.max(1, Math.floor(ms / 60_000));
    return `${minutes} мин`;
}
/** Compact age for matrix cells: «62 д» or «≈ 90 д». */
export function formatCompactStageAge(ms, estimated = false) {
    if (ms == null || !Number.isFinite(ms) || ms < 0)
        return '';
    const days = Math.floor(ms / 86_400_000);
    const hours = Math.floor((ms % 86_400_000) / 3_600_000);
    let body;
    if (days >= 1)
        body = `${days} д`;
    else if (hours >= 1)
        body = `${hours} ч`;
    else
        body = `${Math.max(1, Math.floor(ms / 60_000))} мин`;
    return estimated ? `≈ ${body}` : body;
}
